module.exports = __webpack_public_path__ + "static/img/lastTop.b5ad5e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buchong/lastTop.jpg
// module id = 2M7E
// module chunks = 1